import styled from 'styled-components';
import { ModalBody, ModalFooter } from '../../components/Modal/styles';

interface PropsAvatar {
  backgroundColor: string;
  avatarSize: number | string;
}

interface PropsStatus {
  statusColor: string;
}

export const Content = styled.div`
  width: 100%;
  font-size: 14px;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 16px;

    @media (max-width: 650px) {
      flex-wrap: nowrap;
    }

    ${ModalBody} {
      margin: 0px;
    }

    ${ModalFooter} {
      margin-left: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      > button {
        width: 100%;
        height: 49px;
        margin-bottom: 16px;
        border: 1px solid ${props => props.theme.colors?.primary.main.color};
      }
    }

    > div:first-child {
      align-items: center;
      display: flex;
      color: #000000;
      > img + p,
      > p {
        width: auto;
      }
    }
  }
`;

export const DivAvatarPicture = styled.div<PropsAvatar>`
  width: ${props => props.avatarSize};
  height: ${props => props.avatarSize};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${props => props.backgroundColor};
  color: white;
  font-size: 14px;

  > p {
    margin: 0 auto;
  }
`;

export const NameAccount = styled.h3`
  margin-left: 16px;
  margin-bottom: 4px;
  margin-top: 0px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: #333333;
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;
  margin-bottom: 0px;
  margin-top: 0px;
  font-style: normal;

  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: #333333;

  > p {
    margin: 0px 5px 0px 0px;
  }

  @media (max-width: 650px) {
    font-size: 14px;
  }
`;

export const LabelStatus = styled.span<PropsStatus>`
  color: ${props => props.statusColor};
`;

export const StylePartner = styled.div`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;

  > p {
    margin-bottom: 12px;
  }

  > a {
    font-weight: 700;
    text-decoration-line: underline;
    text-decoration-style: solid;
    color: #333 !important;
  }

  > ul {
    margin-left: 0px;
    padding-left: 0px;
    line-height: 19px;
    text-align: left;

    li {
      space-line: 1.5px;
    }
  }

  @media (max-width: 650px) {
    text-align: center;
  }
`;

export const ContentPartner = styled.div`
  margin: 0;
  padding: 0 32px;
  @media (max-width: 650px) {
    padding: 0 24px;
  }
`;

export const TitleModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  font-weight: 600;
  font-size: 28px;
  line-height: 40px;
  margin-bottom: 24px;
  padding: 0 32px;

  > p {
    margin: 0 0 0 24px;
    font-size: 28px;
  }

  @media (max-width: 650px) {
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 22px;
    line-height: 30px;
    margin-bottom: 16px;
    padding: 0 24px;

    > p {
      margin: 16px 0 0 0;
    }
  }
`;

export const StyleTitle = styled.div`
  width: 100%;
  > p {
    margin: 0;
    line-height: 21.79px;
    ~ p {
      margin-top: 13px;
    }
`;

export const StyleSubTitle = styled(StyleTitle)`
  margin-bottom: 40px;
`;

export const SubTitle = styled.h2`
  font-family: 'Inter';
  font-style: normal;
  padding-top: 48px;
  font-size: 16px;
  margin-bottom: 24px;
`;
